import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../lib/api";

const input = "mt-1 w-full rounded-md border border-linen bg-ivory px-3 py-2.5 text-sm outline-none focus:border-forest";
const label = "text-xs font-semibold uppercase tracking-[0.15em] text-moss";

export default function BannerTab() {
  const [banner, setBanner] = useState({ enabled: false, text: "", link_label: "", link_url: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/banner").then((res) => setBanner({ enabled: false, text: "", link_label: "", link_url: "", ...res.data }));
  }, []);

  const set = (k) => (e) => setBanner((b) => ({ ...b, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/admin/banner", banner);
      setBanner(data);
      toast.success(data.enabled ? "Banner is live on the website" : "Banner saved (hidden)");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="banner-tab" className="max-w-2xl">
      <h2 className="font-serif text-3xl font-medium text-forest">Specials Banner</h2>
      <p className="mt-1 text-sm text-moss">A slim announcement bar at the very top of the website. Visitors can dismiss it for their session.</p>

      <form onSubmit={save} className="mt-6 space-y-5 rounded-lg border border-linen bg-ivory p-6">
        <label className="flex items-center gap-3 text-sm font-medium text-forest">
          <input data-testid="banner-enabled-toggle" type="checkbox" checked={banner.enabled} onChange={set("enabled")} className="h-4 w-4 accent-forest" />
          Show banner on the website
        </label>
        <div>
          <label className={label}>Banner text</label>
          <input data-testid="banner-text-input" maxLength={200} value={banner.text} onChange={set("text")} placeholder="September Special: $10/unit Botox all month" className={input} />
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          <div>
            <label className={label}>Button label (optional)</label>
            <input data-testid="banner-link-label-input" maxLength={40} value={banner.link_label} onChange={set("link_label")} placeholder="Book now" className={input} />
          </div>
          <div>
            <label className={label}>Button link (optional)</label>
            <input data-testid="banner-link-url-input" value={banner.link_url} onChange={set("link_url")} placeholder="/book?service=botox" className={input} />
          </div>
        </div>
        {banner.text && (
          <div>
            <p className={label}>Preview</p>
            <div data-testid="banner-preview" className="mt-2 flex flex-wrap items-center justify-center gap-4 rounded-md bg-forest px-4 py-2.5 text-center text-sm text-ivory">
              <span>{banner.text}</span>
              {banner.link_label && <span className="font-semibold underline underline-offset-4">{banner.link_label}</span>}
            </div>
          </div>
        )}
        <button type="submit" data-testid="banner-save-button" disabled={busy} className="rounded-md bg-forest px-5 py-2.5 text-sm font-semibold text-ivory transition-colors hover:bg-forest-dark disabled:opacity-50">{busy ? "Saving..." : "Save Banner"}</button>
      </form>
    </div>
  );
}
